import { useEffect, useState } from "react";

const getConnection = () => {
	if (typeof navigator === "undefined") {
		return undefined;
	}

	return (
		navigator.connection ||
		navigator.mozConnection ||
		navigator.webkitConnection
	);
};

const readConnectionDetails = (connection) => {
	if (!connection) {
		return undefined;
	}

	return {
		type: connection.type,
		effectiveType: connection.effectiveType,
		downlink: connection.downlink,
		rtt: connection.rtt,
		saveData: connection.saveData,
	};
};

export function useNetworkInfo() {
	const [isOnline, setIsOnline] = useState(
		() => typeof navigator === "undefined" || navigator.onLine,
	);
	const [connectionDetails, setConnectionDetails] = useState();

	useEffect(() => {
		const updateNetworkStatus = () => setIsOnline(navigator.onLine);
		const networkConnection = getConnection();
		setConnectionDetails(readConnectionDetails(networkConnection));

		const updateConnectionDetails = () => {
			setConnectionDetails(readConnectionDetails(networkConnection));
		};

		window.addEventListener("online", updateNetworkStatus);
		window.addEventListener("offline", updateNetworkStatus);

		if (networkConnection) {
			networkConnection.addEventListener("change", updateConnectionDetails);
		}

		return () => {
			window.removeEventListener("online", updateNetworkStatus);
			window.removeEventListener("offline", updateNetworkStatus);

			if (networkConnection) {
				networkConnection.removeEventListener("change", updateConnectionDetails);
			}
		};
	}, []);

	console.log(isOnline, connectionDetails);

	return {
		isOnline,
		connectionDetails,
	};
}

export default useNetworkInfo;
